import { useEffect, useState } from 'react'
import { dnsAPI } from '../api/client'
import type { DnsPublication, EmailVerification } from '../api/types'

export function DnsPublicationPanel({ domainId, revision }: { domainId: number; revision?: unknown }) {
  const [publication, setPublication] = useState<DnsPublication | null>(null)
  const [verification, setVerification] = useState<EmailVerification | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  useEffect(() => {
    let cancelled = false
    setPublication(null)
    setVerification(null)
    setError(null)
    dnsAPI.publication(domainId).then(result => { if (!cancelled) setPublication(result) })
      .catch(() => { if (!cancelled) setError('Could not check DNS publication. Saved records may not be published.') })
    return () => { cancelled = true }
  }, [domainId, revision])
  const run = async (action: 'publish' | 'verify') => {
    setBusy(true)
    setError(null)
    try {
      if (action === 'publish') setPublication(await dnsAPI.publish(domainId))
      else setVerification(await dnsAPI.verifyEmail(domainId))
    } catch (e) { setError(e instanceof Error ? e.message : 'Check failed') }
    finally { setBusy(false) }
  }
  return <section aria-label="DNS publication and email verification" className="rounded border p-4 space-y-3">
    <h2 className="font-semibold">DNS publication</h2>
    <p role="status">{publication ? `${publication.state}: ${publication.detail}` : 'Checking publication…'}</p>
    {error && <p role="alert" className="text-red-600">{error}</p>}
    <div className="flex gap-4">
      <button type="button" disabled={busy || !publication || ['disabled', 'unauthorized'].includes(publication.state)} onClick={() => void run('publish')}>Publish / retry</button>
      <button type="button" disabled={busy} onClick={() => void run('verify')}>Verify email DNS</button>
    </div>
    {verification && <div className="space-y-2">
      <p>Email DNS: {verification.dns_status}. Delivery: not tested.</p>
      <ul>{verification.checks.map(check => <li key={check.check}><strong>{check.check}: {check.status}</strong> — {check.detail}</li>)}</ul>
      <p className="text-sm">{verification.detail}</p>
    </div>}
  </section>
}
